//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.FeatureBendPropertiesListBuilder.js";
import "../no/Features.js";
let d=[[],[[[],"CreateFlangeBendProperties",{R_:{listitem:"Features.SheetMetal.FlangeBendPropertiesBuilder"}},0,0]],[]];
SPLM.Features.SheetMetal.FlangeBendPropertiesListBuilder = class extends SPLM.Features.SheetMetal.FeatureBendPropertiesListBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.FlangeBendPropertiesListBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;